import React, { useState, useEffect, createContext, useContext } from "react";
import { useLocalstorageState } from "rooks";
import { ICustomer, IAdvanceSearch } from "types";

export interface CustomerContextInterface {
  /** Page Index */
  pageIndex: number;
  /** Page Count */
  pageCount: number;
  /** Customers */
  customers: ICustomer[];
  /** Filter or Search */
  isFiltered: boolean;
  /** Search Key */
  searchKey: string;
  /** Advance Search Open / Close */
  advanceOpen: boolean;
	/** Perform searching */
	searchClicked: boolean;
  /** Advance Search Fields */
  searchFields: IAdvanceSearch[];
  /** Set Pgae Index */
  updatePageIndex(params): void;
  /** Set Pgae Count */
  updatePageCount(params): void;
  /** Set Customers */
  updateCustomers(params): void;
  /** Set isFiltered */
  updateIsFiltered(params): void;
  updateSearchKey(params): void;
  updateAdvanceOpen(params): void;
	updateSearchClicked(params): void;
  updateSearchFields(params): void;
  clearCustomerData(): void;
}

const initialFields: IAdvanceSearch[] = [
  {
    order: 0,
    name: "Phone number",
    isSelected: false,
    isAvailable: false,
    searchType: "Equal to",
    value: "",
  },
  {
    order: 1,
    name: "Email address",
    isSelected: true,
    isAvailable: true,
    searchType: "Equal to",
    value: "",
  },
  {
    order: 2,
    name: "First name",
    isSelected: true,
    isAvailable: true,
    searchType: "Start with",
    value: "",
  },
  {
    order: 3,
    name: "Last name",
    isSelected: true,
    isAvailable: true,
    searchType: "Start with",
    value: "",
  },
  {
    order: 4,
    name: "Zip code",
    isSelected: false,
    isAvailable: false,
    searchType: "Equal to",
    value: ""
  },
  {
    order: 5,
    name: "City",
    isSelected: false,
    isAvailable: true,
    searchType: "Equal to",
    value: ""
  },
  {
    order: 6,
    name: "State",
    isSelected: false,
    isAvailable: true,
    searchType: "Equal to",
    value: ""
  },
  {
    order: 7,
    name: "Country",
    isSelected: false,
    isAvailable: true,
    searchType: "Equal to",
    value: ""
  },
  {
    order: 8,
    name: "Master Customer Id",
    isSelected: false,
    isAvailable: true,
    searchType: "Equal to",
    value: "",
  },
];

const initialState: CustomerContextInterface = {
  pageIndex: 0,
  pageCount: 0,
  customers: [],
  isFiltered: false,
  searchKey: "",
  advanceOpen: true,
	searchClicked: false,
  searchFields: initialFields,
  updatePageIndex: () => { },
  updatePageCount: () => { },
  updateCustomers: () => { },
  updateIsFiltered: () => { },
  updateSearchKey: () => { },
  updateAdvanceOpen: () => { },
	updateSearchClicked: () => { },
  updateSearchFields: () => { },
  clearCustomerData: () => { },
};

export const CustomerContext = createContext<CustomerContextInterface>(
  initialState as CustomerContextInterface
);

export const useCustomerContext = () => useContext(CustomerContext);

export const CustomerProvider = ({ children }) => {
  const [pageIndex, setPageIndex] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(0);
  const [customers, setCustomers] = useState<ICustomer[]>([]);
  const [isFiltered, setIsFiltered] = useState<boolean>(false);
  const [searchKey, setSearchKey] = useState<string>("");
  const [advanceOpen, setAdvanceOpen] = useState<boolean>(true);
	const [searchClicked, setSearchClicked] = useState<boolean>(false);
  const [searchFields, setSearchFields] = useState<IAdvanceSearch[]>(initialFields);

  const updatePageIndex = (val) => {
    setPageIndex(val);
  };

  const updatePageCount = (val) => {
    setPageCount(val);
  };

  const updateCustomers = (val) => {
    setCustomers(val);
  };

  const updateIsFiltered = (val) => {
    setIsFiltered(val);
  };

  const updateSearchKey = (val) => {
    setSearchKey(val);
  };

  const updateAdvanceOpen = (val) => {
    setAdvanceOpen(val);
  };

	const updateSearchClicked = (val) => {
		setSearchClicked(val);
	};

  const updateSearchFields = (val) => {
    setSearchFields(val);
  };

  const clearCustomerData = () => {
    setPageIndex(0);
    setPageCount(0);
    setCustomers([]);
    setIsFiltered(false);
    setSearchKey("");
    setAdvanceOpen(true);
		setSearchClicked(false);
    setSearchFields(initialFields);
  }

  return (
    <CustomerContext.Provider
      value={{
        pageIndex,
        pageCount,
        customers,
        isFiltered,
        searchKey,
        advanceOpen,
				searchClicked,
        searchFields,
        updatePageIndex,
        updatePageCount,
        updateCustomers,
        updateIsFiltered,
        updateSearchKey,
        updateAdvanceOpen,
				updateSearchClicked,
        updateSearchFields,
        clearCustomerData,
      }}
    >
      {children}
    </CustomerContext.Provider>
  );
};
